@if (visible()) {
  <div class="rm-backdrop" tabindex="-1" (click)="onBackdropClick($event)" (keydown.escape)="close()">
    <div
      class="rm-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="rm-title"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
    >
      <div class="rm-head">
        <h2 id="rm-title" class="rm-head__title">{{ 'testResults.report.title' | translate }}</h2>
        <p class="rm-head__sub">
          @if (data(); as d) {
            {{ 'testResults.report.subtitleStand' | translate: { date: d.stand | date: 'dd.MM.yyyy' } }}
          } @else {
            {{ 'testResults.report.subtitle' | translate }}
          }
        </p>
      </div>

      <div class="rm-body">
        <div id="rm-label-art" class="rm-label">{{ 'testResults.report.sections.art' | translate }}</div>
        <div class="rm-opts" role="radiogroup" aria-labelledby="rm-label-art" data-group="art">
          @for (a of arts; track a) {
            <label class="rm-opt" [class.rm-opt--on]="art() === a">
              <input
                class="sr-only"
                type="radio"
                name="rm-art"
                [value]="a"
                [checked]="art() === a"
                (change)="art.set(a)"
              />
              <span class="rm-opt__title">{{ 'testResults.report.art.' + a + '.title' | translate }}</span>
              &ngsp;
              <span class="rm-opt__desc">{{ 'testResults.report.art.' + a + '.desc' | translate }}</span>
            </label>
          }
        </div>

        <div id="rm-label-umfang" class="rm-label">{{ 'testResults.report.sections.umfang' | translate }}</div>
        <div class="rm-opts" role="radiogroup" aria-labelledby="rm-label-umfang" data-group="umfang">
          <label class="rm-opt" [class.rm-opt--on]="umfang() === 'RELEASE'">
            <input
              class="sr-only"
              type="radio"
              name="rm-umfang"
              value="RELEASE"
              [checked]="umfang() === 'RELEASE'"
              (change)="umfang.set('RELEASE')"
            />
            <span class="rm-opt__title">{{ releaseLabel() }}</span>
            @let count = planCount();
            @if (count !== null) {
              <span class="rm-opt__desc">
                {{
                  (count === 1 ? 'testResults.report.umfang.planCountOne' : 'testResults.report.umfang.planCount')
                    | translate: { count: count }
                }}
              </span>
            }
          </label>
          <label class="rm-opt" [class.rm-opt--on]="umfang() === 'PLAN'">
            <input
              class="sr-only"
              type="radio"
              name="rm-umfang"
              value="PLAN"
              [checked]="umfang() === 'PLAN'"
              (change)="umfang.set('PLAN')"
            />
            <span class="rm-opt__title">{{ 'testResults.report.umfang.plan' | translate }}</span>
          </label>
        </div>
        @if (umfang() === 'PLAN') {
          <label class="sr-only" for="rm-plan">{{ 'testResults.report.umfang.planSelectLabel' | translate }}</label>
          <select
            id="rm-plan"
            class="rm-select"
            data-testid="report-plan-select"
            (change)="choosePlan($any($event.target).value)"
          >
            @for (p of plans(); track p.id) {
              <option [value]="p.id" [selected]="p.id === selectedPlan()?.id">{{ planLabel(p) }}</option>
            }
          </select>
        }

        <div class="rm-label">{{ 'testResults.report.sections.preview' | translate }}</div>
        @if (loading()) {
          <p class="rm-loading" role="status">{{ 'testResults.report.loading' | translate }}</p>
        } @else if (plansFailed()) {
          <p class="rm-error" role="alert">{{ 'testResults.report.errors.plans' | translate }}</p>
        } @else if (preview().error; as message) {
          <p class="rm-error" role="alert">{{ message }}</p>
        } @else if (!data() || isEmpty()) {
          <p class="rm-empty">{{ 'testResults.report.empty' | translate }}</p>
        } @else if (data(); as d) {
          @if (d.traceability; as rows) {
            <div class="rm-trace-wrap">
              <table class="rm-trace">
                <colgroup>
                  <col class="rm-trace__col-req" />
                  <col class="rm-trace__col-tc" />
                  <col class="rm-trace__col-result" />
                  <col class="rm-trace__col-short" />
                  <col class="rm-trace__col-short" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{ 'testResults.report.trace.requirement' | translate }}</th>
                    <th scope="col">{{ 'testResults.report.trace.testCase' | translate }}</th>
                    <th scope="col">{{ 'testResults.report.trace.result' | translate }}</th>
                    <th scope="col">{{ 'testResults.report.trace.run' | translate }}</th>
                    <th scope="col">{{ 'testResults.report.trace.bug' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (r of rows; track $index) {
                    <tr [class.rm-trace__row--missing]="!r.testCaseId">
                      <td>
                        <code class="rm-trace__req-id">{{ r.requirementKey }}</code>
                        <span class="rm-trace__req-title">{{ r.requirementTitel }}</span>
                      </td>
                      <td>
                        @if (r.testCaseId) {
                          <code class="rm-trace__tc-id">{{ r.testCaseKey }}</code>
                          <span class="rm-trace__tc-title">{{ r.testCaseTitel }}</span>
                        } @else {
                          <span class="rm-trace__missing">
                            <span aria-hidden="true">⚠</span>
                            {{ 'testResults.report.trace.noTestCase' | translate }}
                          </span>
                        }
                      </td>
                      <td class="rm-trace__result">
                        @if (resultOf(r); as result) {
                          <app-res-pill size="sm" [status]="result.pill" [label]="result.labelKey | translate" />
                        } @else {
                          <span class="rm-dash">—</span>
                        }
                      </td>
                      <td class="rm-trace__lauf">{{ r.laufKey || '—' }}</td>
                      <td class="rm-trace__bug" [class.rm-dash]="!r.bugKey">{{ r.bugKey || '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else if (d.abschluss; as a) {
            <div class="rm-sum">
              <div class="rm-sum__title">
                {{ 'testResults.report.summary.title' | translate: { scope: scopeLabel(d) } }}
              </div>
              <div class="rm-sum__tiles">
                <div class="rm-tile" data-tile="ausgefuehrt">
                  <div class="rm-tile__label">{{ 'testResults.report.summary.executed' | translate }}</div>
                  <div class="rm-tile__value">{{ a.ausgefuehrt }}/{{ a.gesamt }}</div>
                </div>
                <div class="rm-tile" data-tile="passrate">
                  <div class="rm-tile__label">{{ 'testResults.report.summary.passRate' | translate }}</div>
                  <div class="rm-tile__value">{{ a.ausgefuehrt === 0 ? '—' : a.passRate + '%' }}</div>
                </div>
                <div class="rm-tile" data-tile="failed">
                  <div class="rm-tile__label">{{ 'testResults.report.summary.failed' | translate }}</div>
                  <div class="rm-tile__value">{{ a.failed }}</div>
                </div>
                <div class="rm-tile" data-tile="blocked">
                  <div class="rm-tile__label">{{ 'testResults.report.summary.blocked' | translate }}</div>
                  <div class="rm-tile__value">{{ a.blocked }}</div>
                </div>
              </div>
              <div class="rm-sum__rec">
                <span class="rm-sum__rec-label">{{ 'testResults.report.summary.recommendation' | translate }}</span>
                @if (ampel(); as state) {
                  <app-ampel-badge size="sm" [state]="state" />
                }
              </div>
              @if (casesWithDefects(a); as cases) {
                <div class="rm-defects">
                  <div class="rm-defects__label">{{ 'defect.ref.openCases' | translate }}</div>
                  <ul class="rm-defects__list">
                    @for (c of cases; track c.planId + c.testCaseId) {
                      <li class="rm-defects__row" data-testid="report-open-defect">
                        <code class="rm-defects__case">{{ c.testCaseKey }}</code>
                        <span class="rm-defects__title">{{ c.titel }}</span>
                        @if (c.bugKey) {
                          <code class="rm-defects__bug">{{ c.bugKey }}</code>
                        }
                        <app-defect-ref-chips [projectId]="projectId()" [defects]="c.defects" />
                      </li>
                    }
                  </ul>
                </div>
              }
              <p class="rm-sum__hint">{{ 'testResults.report.summary.includes' | translate }}</p>
            </div>
          }
        }

        <div id="rm-label-format" class="rm-label">{{ 'testResults.report.sections.format' | translate }}</div>
        <div class="rm-opts" role="radiogroup" aria-labelledby="rm-label-format" data-group="format">
          @for (f of formats; track f) {
            <label class="rm-opt" [class.rm-opt--on]="format() === f">
              <input
                class="sr-only"
                type="radio"
                name="rm-format"
                [value]="f"
                [checked]="format() === f"
                (change)="format.set(f)"
              />
              <span class="rm-opt__title">{{ 'testResults.report.format.' + f + '.title' | translate }}</span>
              &ngsp;
              <span class="rm-opt__desc">{{ 'testResults.report.format.' + f + '.desc' | translate }}</span>
            </label>
          }
        </div>
        @if (confirmation(); as message) {
          <p class="rm-done" role="status">
            <mat-icon aria-hidden="true">check</mat-icon>
            {{ message }}
          </p>
        }
        @if (generateError(); as message) {
          <p class="rm-gen-error" role="alert">{{ message }}</p>
        }
      </div>

      <div class="rm-foot">
        <button type="button" class="rm-btn rm-btn--secondary" data-testid="report-close" (click)="close()">
          {{ 'testResults.report.close' | translate }}
        </button>
        <button
          type="button"
          class="rm-btn rm-btn--primary"
          data-testid="report-generate"
          [disabled]="!canGenerate()"
          (click)="generate()"
        >
          @if (generating()) {
            {{ 'testResults.report.generating' | translate }}
          } @else {
            <span class="rm-btn__icon" aria-hidden="true">↓</span>
            {{ 'testResults.report.generate' | translate }}
          }
        </button>
      </div>
    </div>
  </div>
}
